module.exports = __webpack_public_path__ + "static/david-hollander.46246341.webp";